module.exports = __webpack_public_path__ + "img/rectangle.be5030ca.webp";